<!-- 封装的变异输入框 -->
<template>
  <div ref="editor" class="custom-input1" contenteditable="true" @click="onclick" @input="inputText" @blur="inputBlur" @focus="inputFocus"></div>
</template>

<script>
export default {
  props: ['value'],
  data() {
    return {
      // 真实数据位置
      realDomKeys: [],
      // 储存对应的字符串值
      dataList: [],
      // 光标位置
      focusOffset: 0,
      // 定义最后光标对象
      lastEditRange: null,
      chineseInput: false,
      emojiReg: /[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF][\u200D|\uFE0F]|[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF]|[0-9|*|#]\uFE0F\u20E3|[0-9|#]\u20E3|[\u203C-\u3299]\uFE0F\u200D|[\u203C-\u3299]\uFE0F|[\u2122-\u2B55]|\u303D|[\A9|\AE]\u3030|\uA9|\uAE|\u3030/gi
    }
  },
  watch: {
    value(val) {
      if (val != '') {
        const html = this.$refs.editor.innerHTML
        if(html != val){
          this.$refs.editor.innerHTML = val;
        }
      }else {
        // 外部传来空字符串，可能是点发送后清空了输入框内容，此时需要把其他数据都清掉
        this.$refs.editor.innerHTML = ''
        this.realDomKeys = []
        this.dataList = []
        this.focusOffset = 0
        this.lastEditRange = null
      }
    }
  },
  mounted() {
    // document.execCommand("defaultParagraphSeparator", false, "")
    const el = this.$refs.editor
    el.addEventListener('compositionstart', this.divCompositionstart, false)
    el.addEventListener('compositionend', this.divCompositionend, false)
  },
  beforeDestroy() {
    const el = this.$refs.editor
    el.removeEventListener('compositionstart', this.divCompositionstart, false)
    el.removeEventListener('compositionend', this.divCompositionend, false)
  },
  methods: {
    setDataList(html, type) {
      // 记录数据存储位置(指的是数据所在数组位置的下标值)
      let cursorJS
      // 记录光标存在位置(指的是当前光标前的数据个数)
      let cursorDom = this.focusOffset
      // 判断光标所处位置,如果在中文体内,则放到中文右括号侧,其余情况确认光标的真实指向
      // 光标是否位于最末尾
      if (cursorDom < this.realDomKeys.length && cursorDom > 0) {
        // 判断光标是否在中文体内,如果在就让光标落到此中文最右边(右括号侧
        if (this.realDomKeys[cursorDom] instanceof Object) {
          //  在中文体内
          // 记录光标应该在的位置和对应此刻数据存储位置
          if (cursorDom == this.realDomKeys[cursorDom].start) {
            // console.log('@@光标在中文体旁边')
          } else {
            cursorDom = this.realDomKeys[cursorDom].start + this.realDomKeys[cursorDom].n
            // console.log('@@光标在中文体内')
          }
          cursorJS = this.getCursorJS(cursorDom) - 1 //取的是当前指向数据的下标值
        } else {
          //  不在中文体内
          cursorJS = this.getCursorJS(cursorDom) - 1
          // console.log('@@光标在在中文体外,且在数组内,真实数据位置为', cursorJS)
        }
      } else if (cursorDom == this.realDomKeys.length) {
        // 位于最末尾
        cursorJS = this.dataList.length - 1
      } else if (cursorDom == 0) {
        // 位于最前端
        cursorJS = -1
      }

      // 增减datalist数据
      if (html instanceof Object) {
        // this.dataList.push(val.name)
      } else if (html == 'DEL') {
        // 删除数据
        let str
        if (cursorJS != -1) {
          //如果在最前端刪除無效,即cursorJS=-1和0
          str = this.dataList[cursorJS]
          this.dataList.splice(cursorJS, 1)
          this.setRealDomKeys()
          if (this.emojiReg.test(str)) {
            cursorDom = cursorDom - str.length
          } else {
            cursorDom--
          }
        }
      } else {
        //添加数据
        this.dataList.splice(cursorJS == -1 ? 0 : cursorJS + 1, 0, html)
        this.setRealDomKeys()
        if (type) {
          cursorDom += 2
        } else {
          cursorDom++
        }
      }
      this.focusOffset = cursorDom
      this.keepLastIndex(this.$refs.editor)
    },
    // 重新计算dataList的对应realDomKeys
    setRealDomKeys() {
      const _this = this
      this.realDomKeys = []
      this.dataList.forEach((item, index) => {
        //判断是否为设备名
        // console.log(this.emojiReg.test(item), 'this.emojiReg.test(item)');
        if (_this.emojiReg.test(item)) {
          //凡是包含中文,以及字符串长度大于1的都默认为设备名
          let len = item.length
          let i = 0
          let reaLen = _this.realDomKeys.length
          while (i < len) {
            _this.realDomKeys.push({
              index: index, //对应数据数组的下标值
              start: reaLen, //此数据在realDomKeys起始下标
              n: len, //共占有多少数据格
            })
            i++
          }
        } else {
          _this.realDomKeys.push(index)
        }
      })
    },
    // 获取当光标不在中文体内时,对应的数据位置
    getCursorJS(cursorDom) {
      let count = 0
      let i = 0
      while (i < cursorDom) {
        if (this.realDomKeys[i] instanceof Object) {
          count++
          i += this.realDomKeys[i].n
        } else {
          count++
          i++
        }
      }
      return count
    },
    keepLastIndex(obj) {
      if (window.getSelection) {
        obj.focus()
        // 获取选定对象
        var selection = getSelection()
        if (this.lastEditRange) {
          // 存在最后光标对象，选定对象清除所有光标并添加最后光标还原之前的状态
          selection.removeAllRanges()
          selection.addRange(this.lastEditRange)
        }
        obj.innerHTML = this.getHtml()
        // console.log(selection.anchorNode.childNodes[0], this.focusOffset);
        selection.collapse(selection.anchorNode.childNodes[0], this.focusOffset)
      }
    },
    // 将存储数据转化成html
    getHtml() {
      let str = ''
      this.dataList.forEach((item) => {
        str += item
      })
      return str
    },
    // 點擊editor時獲取光標位置
    onclick(e) {
      let selection = window.getSelection()
      this.lastEditRange = selection.getRangeAt(0)
      this.focusOffset = selection.focusOffset
    },
    // 获取标签内容
    getInnerHTML() {
      return this.$refs.editor.innerHTML
    },
    // 监听输入框内容
    inputText(e) {
      setTimeout(()=>{
        if(this.chineseInput) return
        let text
        if (!e.data && e.inputType == 'deleteContentBackward') {
          // 只有手动退格的inputType是deleteContentBackward，防止ios下输入中文会导致误删文字
          this.setDataList('DEL', 0)
        } else if(e.inputType == 'insertText' || e.inputType == 'insertCompositionText') {
          // 安卓输入汉字的inputType为insertText，ios输入汉字的inputType为insertCompositionText和insertFromComposition，因此会导致ios会多输出一遍，因此ios的只取一个即可
          text = e.data
        }
        if (text) {
          for(let val of text.split('')){
            this.setDataList(val, 0)
          }
        }else{
          this.keepLastIndex(this.$refs.editor)
        }
        // this.$nextTick(()=>{
          this.$emit('input', this.$refs.editor.innerHTML);
        // })
      }, 0)
    },
    divCompositionstart () {
      // 表明在中文输入中，防止ios下把拼音也当做文字记录
      this.chineseInput = true
    },
    divCompositionend (e) {
      // 表明中文输入结束，防止ios下把拼音也当做文字记录
      this.chineseInput = false
    },
    inputFocus() {
    },
    inputBlur() {
      this.$emit('input', this.$refs.editor.innerHTML);
      this.$emit('blur')
    }
  }
}
</script>

<style lang="less" scoped>
.custom-input1{
  width: 100%;
  max-height: 1.48rem;
  overflow-y: auto;
  line-height: 0.48rem;
  outline: #D3D3D3 auto 1px;
  padding-left: 1px;
  -webkit-user-select: text;
  flex: 1;
}
</style>